// @ts-nocheck
if (!Util) function Util() { };

Util.addClass = function (el, className) {
  var classList = className.split(' ');
  el.classList.add(classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function (el, className) {
  var classList = className.split(' ');
  el.classList.remove(classList[0]);
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.hasClass = function (el, className) {
  return el.classList.contains(className);
};

Util.getIndexInArray = function (array, el) {
  return Array.prototype.indexOf.call(array, el);
};

Util.cssSupports = function (property, value) {
  return CSS.supports(property, value);
};

Util.osHasReducedMotion = function () {
  if (!window.matchMedia) return false;
  var matchMediaObj = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (matchMediaObj) return matchMediaObj.matches;
  return false;
};

Util.getChildrenByClassName = function (el, className) {
  var children = el.children,
    childrenByClass = [];
  for (var i = 0; i < children.length; i++) {
    if (Util.hasClass(children[i], className)) childrenByClass.push(children[i]);
  }
  return childrenByClass;
};

Util.setAttributes = function (el, attrs) {
  for (var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

Util.toggleClass = function (el, className, bool) {
  if (bool) Util.addClass(el, className);
  else Util.removeClass(el, className);
};


// File#: _1_progress-bar
(function () {
  var ProgressBar = function (element) {
    this.element = element;
    this.fill = this.element.getElementsByClassName('progress-bar__fill')[0];
    this.label = this.element.getElementsByClassName('progress-bar__value');
    this.value = getProgressBarValue(this);
    // before checking if data-animation is set -> check for reduced motion
    updatedProgressBarForReducedMotion(this);
    this.animate = this.element.hasAttribute('data-animation') && this.element.getAttribute('data-animation') == 'on';
    this.animationDuration = this.element.hasAttribute('data-duration') ? this.element.getAttribute('data-duration') : 1000;
    // animation will run only on browsers supporting IntersectionObserver
    this.canAnimate = ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype);
    // this element is used to announce the percentage value to SR
    this.ariaLabel = this.element.getElementsByClassName('js-progress-bar__aria-value');
    // check if we need to update the bar color
    this.changeColor = Util.hasClass(this.element, 'progress-bar--color-update') && Util.cssSupports('color', 'var(--color-value)');
    if (this.changeColor) {
      this.colorThresholds = getProgressBarColorThresholds(this);
    }
    initProgressBar(this);
    // store id to reset animation
    this.animationId = false;
  };

  // public function
  ProgressBar.prototype.setProgressBarValue = function (value) {
    setProgressBarValue(this, value);
  };

  function getProgressBarValue(progressBar) { // get progress value
    // return (fill width/total width) * 100
    return parseFloat(progressBar.fill.offsetWidth * 100 / progressBar.element.getElementsByClassName('progress-bar__bg')[0].offsetWidth);
  };

  function getProgressBarColorThresholds(progressBar) {
    var thresholds = [];
    var i = 1;
    while (!isNaN(parseInt(getComputedStyle(progressBar.element).getPropertyValue('--progress-bar-color-' + i)))) {
      thresholds.push(parseInt(getComputedStyle(progressBar.element).getPropertyValue('--progress-bar-color-' + i)));
      i = i + 1;
    }
    return thresholds;
  };

  function updatedProgressBarForReducedMotion(progressBar) {
    // if reduced motion is supported and set to reduced -> remove animations
    if (osHasReducedMotion) progressBar.element.removeAttribute('data-animation');
  };

  function initProgressBar(progressBar) {
    // set initial bar color
    if (progressBar.changeColor) updateProgressBarColor(progressBar, progressBar.value);
    // if data-animation is on -> reset the progress bar and animate when entering the viewport
    if (progressBar.animate && progressBar.canAnimate) animateProgressBar(progressBar);
    // reveal fill and label -> --animate and --color-update variations only
    setTimeout(function () { Util.addClass(progressBar.element, 'progress-bar--init'); }, 30);

    // dynamically update value of progress bar
    progressBar.element.addEventListener('updateProgress', function (event) {
      // cancel request animation frame if it was animating
      if (progressBar.animationId) window.cancelAnimationFrame(progressBar.animationId);

      var final = event.detail.value,
        duration = (event.detail.duration) ? event.detail.duration : progressBar.animationDuration;
      var start = getProgressBarValue(progressBar);
      // trigger update animation
      updateProgressBar(progressBar, start, final, duration, function () {
        emitProgressBarEvents(progressBar, 'progressCompleted', progressBar.value + '%');
        // update value of label for SR
        if (progressBar.ariaLabel.length > 0) progressBar.ariaLabel[0].textContent = final + '%';
      });
    });
  };

  function animateProgressBar(progressBar) {
    // reset inital values
    setProgressBarValue(progressBar, 0);

    // listen for the element to enter the viewport -> start animation
    var observer = new IntersectionObserver(progressBarObserve.bind(progressBar), { threshold: [0, 0.1] });
    observer.observe(progressBar.element);
  };

  function progressBarObserve(entries, observer) { // observe progressBar position -> start animation when inside viewport
    var self = this;
    if (entries[0].intersectionRatio.toFixed(1) > 0 && !this.animationTriggered) {
      updateProgressBar(this, 0, this.value, this.animationDuration, function () {
        emitProgressBarEvents(self, 'progressCompleted', self.value + '%');
      });
    }
  };

  function updateProgressBar(progressBar, start, to, duration, cb) {
    var change = to - start,
      currentTime = null;

    var animateFill = function (timestamp) {
      if (!currentTime) currentTime = timestamp;
      var progress = timestamp - currentTime;
      var val = parseInt((progress / duration) * change + start);
      // make sure value is in correct range
      if (change > 0 && val > to) val = to;
      if (change < 0 && val < to) val = to;
      if (progress >= duration) val = to;

      setProgressBarValue(progressBar, val);
      if (progress < duration) {
        progressBar.animationId = window.requestAnimationFrame(animateFill);
      } else {
        progressBar.animationId = false;
        cb();
      }
    };
    if (window.requestAnimationFrame && !osHasReducedMotion) {
      progressBar.animationId = window.requestAnimationFrame(animateFill);
    } else {
      setProgressBarValue(progressBar, to);
      cb();
    }
  };

  function setProgressBarValue(progressBar, value) {
    progressBar.fill.style.width = value + '%';
    if (progressBar.label.length > 0) progressBar.label[0].textContent = value + '%';
    if (progressBar.changeColor) updateProgressBarColor(progressBar, value);
  };

  function updateProgressBarColor(progressBar, value) {
    var className = 'progress-bar--fill-color-' + progressBar.colorThresholds.length;
    for (var i = progressBar.colorThresholds.length; i > 0; i--) {
      if (!isNaN(progressBar.colorThresholds[i - 1]) && value <= progressBar.colorThresholds[i - 1]) {
        className = 'progress-bar--fill-color-' + i;
      }
    }

    removeProgressBarColorClasses(progressBar);
    Util.addClass(progressBar.element, className);
  };

  function removeProgressBarColorClasses(progressBar) {
    var classes = progressBar.element.className.split(" ").filter(function (c) {
      return c.lastIndexOf('progress-bar--fill-color-', 0) !== 0;
    });
    progressBar.element.className = classes.join(" ").trim();
  };

  function emitProgressBarEvents(progressBar, eventName, detail) {
    progressBar.element.dispatchEvent(new CustomEvent(eventName, { detail: detail }));
  };

  window.ProgressBar = ProgressBar;

  //initialize the ProgressBar objects
  var progressBars = document.getElementsByClassName('js-progress-bar');
  var osHasReducedMotion = Util.osHasReducedMotion();
  if (progressBars.length > 0) {
    for (var i = 0; i < progressBars.length; i++) {
      (function (i) { new ProgressBar(progressBars[i]); })(i);
    }
  }
}());

// File#: _1_file-upload
(function () {
  var InputFile = function (element) {
    this.element = element;
    this.input = this.element.getElementsByClassName('file-upload__input')[0];
    this.label = this.element.getElementsByClassName('file-upload__label')[0];
    this.multipleUpload = this.input.hasAttribute('multiple'); // allow for multiple files selection

    // this is the label text element -> when user selects a file, it will be changed from the default value to the name of the file 
    this.labelText = this.element.getElementsByClassName('file-upload__text')[0];
    this.initialLabel = this.labelText.textContent;
    this.nextButton = document.querySelector('.ce-button-file');

    initInputFileEvents(this);
  };

  function initInputFileEvents(inputFile) {
    // make label focusable
    inputFile.label.setAttribute('tabindex', '0');
    inputFile.input.setAttribute('tabindex', '-1');

    // move focus from input to label -> this is triggered when a file is selected or the file picker modal is closed
    inputFile.input.addEventListener('focusin', function (event) {
      inputFile.label.focus();
    });

    // press 'Enter' key on label element -> trigger file selection
    inputFile.label.addEventListener('keydown', function (event) {
      if (event.keyCode && event.keyCode == 13 || event.key && event.key.toLowerCase() == 'enter') { inputFile.input.click(); }
    });

    // file has been selected -> update label text
    inputFile.input.addEventListener('change', function (event) {
      updateInputLabelText(inputFile);
    });
  };

  function updateInputLabelText(inputFile) {
    var label = '';
    if (inputFile.input.files && inputFile.input.files.length < 1) {
      label = inputFile.initialLabel; // no selection -> revert to initial label
      inputFile.nextButton.disabled = true; // disable next button
    } else if (inputFile.multipleUpload && inputFile.input.files && inputFile.input.files.length > 1) {
      label = inputFile.input.files.length + ' files'; // multiple selection -> show number of files
      inputFile.nextButton.disabled = false; // enable next button
    } else {
      var file = inputFile.input.files[0];
      label = inputFile.input.value.split('\\').pop(); // single file selection -> show name of the file
      if (file.type.startsWith('image/')) {
        inputFile.nextButton.disabled = false; // enable next button if file is an image
      } else {
        inputFile.nextButton.disabled = true; // disable next button if file is not an image
      }
    }
    inputFile.labelText.textContent = label;
  };

  //initialize the InputFile objects
  var inputFiles = document.getElementsByClassName('file-upload');
  if (inputFiles.length > 0) {
    for (var i = 0; i < inputFiles.length; i++) {
      (function (i) { new InputFile(inputFiles[i]); })(i);
    }
  }
}());


// File#: _1_drawer
(function () {
  var Drawer = function (element) {
    this.element = element;
    this.content = document.getElementsByClassName('js-drawer__body')[0];
    this.triggers = document.querySelectorAll('[aria-controls="' + this.element.getAttribute('id') + '"]');
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.selectedTrigger = null;
    this.isModal = this.element.classList.contains('js-drawer--modal');
    this.showClass = "ce-drawer--is-visible";
    this.preventScrollEl = this.getPreventScrollEl();
    this.initDrawer();
  };

  Drawer.prototype.getPreventScrollEl = function () {
    var scrollEl = false;
    var querySelector = this.element.getAttribute('data-drawer-prevent-scroll');
    if (querySelector) scrollEl = document.querySelector(querySelector);
    return scrollEl;
  };

  Drawer.prototype.initDrawer = function () {
    var self = this;
    //open drawer when clicking on trigger buttons
    if (this.triggers) {
      for (var i = 0; i < this.triggers.length; i++) {
        this.triggers[i].addEventListener('click', function (event) {
          event.preventDefault();
          if (self.element.classList.contains(self.showClass)) {
            self.closeDrawer(event.target);
            return;
          }
          self.selectedTrigger = event.target;
          self.showDrawer();
          self.initDrawerEvents();
        });
      }
    }

    // if drawer is already open -> we should initialize the drawer events
    if (this.element.classList.contains(this.showClass)) this.initDrawerEvents();
  };

  Drawer.prototype.showDrawer = function () {
    var self = this;
    this.content.scrollTop = 0;
    this.element.classList.add(this.showClass);
    this.getFocusableElements();
    moveFocus(this.element);
    // wait for the end of transitions before moving focus
    this.element.addEventListener("transitionend", function cb(event) {
      moveFocus(self.element);
      self.element.removeEventListener("transitionend", cb);
    });
    this.emitDrawerEvents('drawerIsOpen', this.selectedTrigger);
    // change the overflow of the preventScrollEl
    if (this.preventScrollEl) this.preventScrollEl.style.overflow = 'hidden';
  };

  Drawer.prototype.openDrawer = function () {
    this.showDrawer();
    this.initDrawerEvents();
  };

  Drawer.prototype.closeDrawer = function (target) {
    this.element.classList.remove(this.showClass);
    this.firstFocusable = null;
    this.lastFocusable = null;
    if (this.selectedTrigger) this.selectedTrigger.focus();
    //remove listeners
    this.cancelDrawerEvents();
    this.emitDrawerEvents('drawerIsClose', target);
    // change the overflow of the preventScrollEl
    if (this.preventScrollEl) this.preventScrollEl.style.overflow = '';
  };

  Drawer.prototype.initDrawerEvents = function () {
    //add event listeners
    this.element.addEventListener('keydown', this);
    this.element.addEventListener('click', this);
  };

  Drawer.prototype.cancelDrawerEvents = function () {
    //remove event listeners
    this.element.removeEventListener('keydown', this);
    this.element.removeEventListener('click', this);
  };

  Drawer.prototype.handleEvent = function (event) {
    switch (event.type) {
      case 'click': {
        this.initClick(event);
      }
      case 'keydown': {
        this.initKeyDown(event);
      }
    }
  };

  Drawer.prototype.initKeyDown = function (event) {
    if (event.keyCode && event.keyCode == 27 || event.key && event.key == 'Escape') {
      //close drawer window on esc
      this.closeDrawer(false);
    } else if (this.isModal && (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab')) {
      //trap focus inside drawer
      this.trapFocus(event);
    }
  };

  Drawer.prototype.initClick = function (event) {
    //close drawer when clicking on close button or drawer bg layer 
    if (!event.target.closest('.js-drawer__close') && !event.target.classList.contains('js-drawer')) return;
    event.preventDefault();
    this.closeDrawer(event.target);
  };

  Drawer.prototype.trapFocus = function (event) {
    if (this.firstFocusable == document.activeElement && event.shiftKey) {
      //on Shift+Tab -> focus last focusable element when focus moves out of drawer
      event.preventDefault();
      this.lastFocusable.focus();
    }
    if (this.lastFocusable == document.activeElement && !event.shiftKey) {
      //on Tab -> focus first focusable element when focus moves out of drawer
      event.preventDefault();
      this.firstFocusable.focus();
    }
  }

  Drawer.prototype.getFocusableElements = function () {
    //get all focusable elements inside the drawer
    var allFocusable = this.element.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary');
    this.getFirstVisible(allFocusable);
    this.getLastVisible(allFocusable);
  };

  Drawer.prototype.getFirstVisible = function (elements) {
    //get first visible focusable element inside the drawer
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
        this.firstFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.getLastVisible = function (elements) {
    //get last visible focusable element inside the drawer
    for (var i = elements.length - 1; i >= 0; i--) {
      if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
        this.lastFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.emitDrawerEvents = function (eventName, target) {
    var event = new CustomEvent(eventName, { detail: target });
    this.element.dispatchEvent(event);
  };

  function moveFocus(element) {
    element.focus();
    if (document.activeElement !== element) {
      element.setAttribute('tabindex', '-1');
      element.focus();
    }
  };

  window.Drawer = Drawer;

  //initialize the Drawer objects
  var drawerElements = document.getElementsByClassName('js-drawer');
  var drawers = [];

  if (drawerElements.length > 0) {
    for (var i = 0; i < drawerElements.length; i++) {
      var drawer = new Drawer(drawerElements[i]);
      drawers[drawer.element.getAttribute('id')] = drawer;
    }
  }

  window.multiStepDrawer = drawers['ce-multi-step'];

}());

function customRemoveWithAddons(event) {
  event.preventDefault();
  var buttonRemove = event.target.closest('.ce-remove-button');
  // One click, one removal: a button may carry its own listener AND be caught by the delegated one below.
  if (!buttonRemove || buttonRemove.dataset.ceRemoving === 'true') return;
  buttonRemove.dataset.ceRemoving = 'true';

  var itemId = buttonRemove.getAttribute('data-main-variant-id');
  var mainProductSKU = buttonRemove.getAttribute('data-main-product-sku');
  var groupId = buttonRemove.getAttribute('data-group-id');
  var loaderRemove = buttonRemove ? buttonRemove.previousElementSibling : null;

  if (loaderRemove && buttonRemove) {
    loaderRemove.style.display = 'block';
    buttonRemove.style.display = 'none';
  }
  customRemoveItemWithAddons(itemId, mainProductSKU, groupId);
}
window.customRemoveWithAddons = customRemoveWithAddons;

// Delegated on purpose: the cart is repainted by the theme, by this configurator and by apps, and a freshly
// painted button has no listener of its own (it stayed dead after an app's `cart:update` until a reload).
document.addEventListener('click', function (event) {
  var target = event.target;
  if (target && target.closest && target.closest('.ce-remove-button__wrapper .ce-remove-button')) customRemoveWithAddons(event);
});

// Horizon 2.x only repaints its cart from the theme-private `cart:update` event; apps and Shopify's own cart
// actions announce a change with the STANDARD `shopify:cart:lines-update`, which this theme generation never
// hears (the drawer opened with "Tu carrito esta vacio" over a full cart). Translate one into the other: fetch
// the cart lines section and hand it to the theme the way its own flows do. Horizon 4.x (<theme-drawer>) listens
// to the standard event natively, so this steps aside there.
(function () {
  var pending = null;
  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (document.querySelector('theme-drawer')) return;
    var items = document.querySelector('cart-items-component[data-section-id]');
    if (!items || pending) return;
    var sectionId = items.dataset.sectionId;
    var announced = (event.detail && event.detail.promise) || event.promise;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    pending = Promise.resolve(announced).catch(function () {}).then(function (payload) {
      // Idempotent: when the page already shows the announced cart (the app dispatches `cart:update` first and
      // the theme morphs on it), there is nothing to translate — refetching would blank the list for a round trip.
      var announcedCount = payload && payload.cart && typeof payload.cart.totalQuantity === 'number' ? payload.cart.totalQuantity : null;
      var shown = items.querySelector('[ref="cartItemCount"]');
      var shownCount = shown ? parseInt(shown.textContent, 10) || 0 : 0;
      if (announcedCount !== null && announcedCount === shownCount) return null;
      // The app opens the drawer right after announcing the change: never show a stale "empty cart" meanwhile.
      items.style.visibility = 'hidden';
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ sections: sectionId, sections_url: window.location.pathname })
      });
    }).then(function (response) { return response ? response.json() : null; }).then(function (cart) {
      if (!cart) return;
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'standard-cart-event', data: { source: 'standard-cart-event', itemCount: cart.item_count, sections: cart.sections } }
      }));
    }).catch(function (error) {
      console.error('cart:update from the standard cart event failed', error);
    }).then(function () {
      pending = null;
      var current = document.querySelector('cart-items-component[data-section-id]');
      if (current) current.style.visibility = '';
      items.style.visibility = '';
    });
  });
}());

function customRemoveItemWithAddons(itemId, mainProductSKU, groupId) {
  mainProductSKU = String(mainProductSKU);
  groupId = String(groupId);

  function removeItemsSequentially() {
    return new Promise((resolve, reject) => {
      CartJS.getCart({
        success: function (cart) {
          var mainLine = null;
          var upsellLines = [];
          var addonLines = [];

          // Clasificar las líneas en upsells, addons y main
          cart.items.forEach((item, index) => {
            if (item.properties && String(item.properties._p_groupId) === groupId) {
              const lineIndex = index + 1; // Las líneas en CartJS son indexadas desde 1
              if (item.properties._p_productType === 'main') {
                mainLine = lineIndex; // Guardar línea del main para eliminar al final
              } else if (item.properties._p_productType === 'addon') {
                addonLines.push(lineIndex); // Guardar líneas de addons
              } else if (item.properties._p_productType === 'upsell') {
                upsellLines.push(lineIndex); // Guardar líneas de upsells
              }
            }
          });

          // Crear la lista final de líneas a eliminar en el orden deseado
          var linesToRemove = upsellLines.concat(addonLines);
          if (mainLine !== null) {
            linesToRemove.push(mainLine); // Agregar el main al final
          }

          // Verificar que los números de línea sean correctos
          linesToRemove = [...new Set(linesToRemove)]; // Eliminar duplicados
          linesToRemove = linesToRemove.filter(line => line > 0 && line <= cart.items.length); // Filtrar líneas válidas

          console.log("Lines to remove after validation:", linesToRemove);

          if (linesToRemove.length === 0) {
            console.log("All items removed");

            // Aquí va el código para actualizar el contador de ítems o el carrito si es necesario
            var removeLoaders = document.querySelectorAll('.ce-remove-button__wrapper .ce-line-item__loader');
            var removeButtons = document.querySelectorAll('.ce-remove-button__wrapper .ce-remove-button');
            if (removeLoaders.length === removeButtons.length) {
              removeLoaders.forEach(function (loader, index) {
                var removeButton = removeButtons[index];
                if (loader && removeButton) {
                  loader.style.display = 'none';
                  if (removeButton.getAttribute('data-product-type') === 'main') {
                    removeButton.style.display = 'block';
                  }
                }
              });
            } else {
              console.error('The number of loaders and custom removes does not match.');
            }
            const cartUpdateEvent = new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                resource: null,
                sourceId: 'multi-step-form',
                data: {
                  source: 'multi-step-form',
                  itemCount: 0,
                  sections: {}
                }
              }
            });
            document.dispatchEvent(cartUpdateEvent);
            if (window.location.pathname === '/cart') {
              window.location.reload();
            }
            resolve();
            return;

          }

          const lineNumber = linesToRemove.shift();
          console.log(`Attempting to remove item at line ${lineNumber}`);
          CartJS.removeItem(lineNumber, {
            success: function () {
              console.log(`Removed item at line ${lineNumber}`);
              resolve(removeItemsSequentially()); // Llamar recursivamente hasta que todos los ítems sean eliminados
            },
            error: function (error) {
              console.error(`Failed to remove item at line ${lineNumber}:`, error);
              resolve(removeItemsSequentially()); // Continuar con la siguiente eliminación incluso si hay un error
            }
          });
        },
        error: function (error) {
          console.error('Error fetching cart:', error);
          reject(error);
        }
      });
    });
  }

  // Iniciar la eliminación secuencial
  removeItemsSequentially().then(() => {
    console.log("Completed all removals");
  }).catch(error => {
    console.error("Failed to complete removals:", error);
  });
};

document.addEventListener('DOMContentLoaded', function () {
  const removeButtons = document.querySelectorAll('.ce-remove-button__wrapper .ce-remove-button');
  removeButtons.forEach(button => {
    button.addEventListener('click', customRemoveWithAddons);
  });
});

// File#: _1_modal-window
(function () {
  var Modal = function (element) {
    this.element = element;
    this.triggers = document.querySelectorAll('[aria-controls="' + this.element.getAttribute('id') + '"]');
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.moveFocusEl = null; // focus will be moved to this element when modal is open
    this.modalFocus = this.element.getAttribute('data-modal-first-focus') ? this.element.querySelector(this.element.getAttribute('data-modal-first-focus')) : null;
    this.selectedTrigger = null;
    this.preventScrollEl = this.getPreventScrollEl();
    this.showClass = "modal--is-visible";
    this.initModal();
  };

  Modal.prototype.getPreventScrollEl = function () {
    var scrollEl = false;
    var querySelector = this.element.getAttribute('data-modal-prevent-scroll');
    if (querySelector) scrollEl = document.querySelector(querySelector);
    return scrollEl;
  };

  Modal.prototype.initModal = function () {
    var self = this;
    //open modal when clicking on trigger buttons
    if (this.triggers) {
      for (var i = 0; i < this.triggers.length; i++) {
        this.triggers[i].addEventListener('click', function (event) {
          event.preventDefault();
          if (self.element.classList.contains(self.showClass)) {
            self.closeModal();
            return;
          }
          self.selectedTrigger = event.currentTarget;
          self.showModal();
          self.initModalEvents();
        });
      }
    }

    // listen to the openModal event -> open modal without a trigger button
    this.element.addEventListener('openModal', function (event) {
      if (event.detail) self.selectedTrigger = event.detail;
      self.showModal();
      self.initModalEvents();
    });

    // listen to the closeModal event -> close modal without a trigger button
    this.element.addEventListener('closeModal', function (event) {
      if (event.detail) self.selectedTrigger = event.detail;
      self.closeModal();
    });

    // if modal is open by default -> initialise modal events
    if (this.element.classList.contains(this.showClass)) this.initModalEvents();
  };

  Modal.prototype.showModal = function () {
    var self = this;
    this.element.classList.add(this.showClass);
    this.getFocusableElements();
    if (this.moveFocusEl) {
      this.moveFocusEl.focus();
      // wait for the end of transitions before moving focus
      this.element.addEventListener("transitionend", function cb(event) {
        self.moveFocusEl.focus();
        self.element.removeEventListener("transitionend", cb);
      });
    }
    this.emitModalEvents('modalIsOpen');
    // change the overflow of the preventScrollEl
    if (this.preventScrollEl) this.preventScrollEl.style.overflow = 'hidden';
  };

  Modal.prototype.closeModal = function () {
    if (!this.element.classList.contains(this.showClass)) return;
    this.element.classList.remove(this.showClass);
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.moveFocusEl = null;
    if (this.selectedTrigger) this.selectedTrigger.focus();
    //remove listeners
    this.cancelModalEvents();
    this.emitModalEvents('modalIsClose');
    // change the overflow of the preventScrollEl
    if (this.preventScrollEl) this.preventScrollEl.style.overflow = '';
  };

  Modal.prototype.initModalEvents = function () {
    //add event listeners
    this.element.addEventListener('keydown', this);
    this.element.addEventListener('click', this);
  };

  Modal.prototype.cancelModalEvents = function () {
    //remove event listeners
    this.element.removeEventListener('keydown', this);
    this.element.removeEventListener('click', this);
  };

  Modal.prototype.handleEvent = function (event) {
    switch (event.type) {
      case 'click': {
        this.initClick(event);
      }
      case 'keydown': {
        this.initKeyDown(event);
      }
    }
  };

  Modal.prototype.initKeyDown = function (event) {
    if (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab') {
      //trap focus inside modal
      this.trapFocus(event);
    } else if ((event.keyCode && event.keyCode == 13 || event.key && event.key == 'Enter') && event.target.closest('.js-modal__close')) {
      event.preventDefault();
      this.closeModal(); // close modal when pressing Enter on close button
    }
  };

  Modal.prototype.initClick = function (event) {
    //close modal when clicking on close button or modal bg layer 
    if (!event.target.closest('.js-modal__close') && !event.target.classList.contains('js-modal')) return;
    event.preventDefault();
    this.closeModal();
  };

  Modal.prototype.trapFocus = function (event) {
    if (this.firstFocusable == document.activeElement && event.shiftKey) {
      //on Shift+Tab -> focus last focusable element when focus moves out of modal
      event.preventDefault();
      this.lastFocusable.focus();
    }
    if (this.lastFocusable == document.activeElement && !event.shiftKey) {
      //on Tab -> focus first focusable element when focus moves out of modal
      event.preventDefault();
      this.firstFocusable.focus();
    }
  }

  Modal.prototype.getFocusableElements = function () {
    //get all focusable elements inside the modal
    var allFocusable = this.element.querySelectorAll(focusableElString);
    this.getFirstVisible(allFocusable);
    this.getLastVisible(allFocusable);
    this.getFirstFocusable();
  };

  Modal.prototype.getFirstVisible = function (elements) {
    //get first visible focusable element inside the modal
    for (var i = 0; i < elements.length; i++) {
      if (isVisible(elements[i])) {
        this.firstFocusable = elements[i];
        break;
      }
    }
  };

  Modal.prototype.getLastVisible = function (elements) {
    //get last visible focusable element inside the modal
    for (var i = elements.length - 1; i >= 0; i--) {
      if (isVisible(elements[i])) {
        this.lastFocusable = elements[i];
        break;
      }
    }
  };

  Modal.prototype.getFirstFocusable = function () {
    if (!this.modalFocus || !Element.prototype.matches) {
      this.moveFocusEl = this.firstFocusable;
      return;
    }
    var containerIsFocusable = this.modalFocus.matches(focusableElString);
    if (containerIsFocusable) {
      this.moveFocusEl = this.modalFocus;
    } else {
      this.moveFocusEl = false;
      var elements = this.modalFocus.querySelectorAll(focusableElString);
      for (var i = 0; i < elements.length; i++) {
        if (isVisible(elements[i])) {
          this.moveFocusEl = elements[i];
          break;
        }
      }
      if (!this.moveFocusEl) this.moveFocusEl = this.firstFocusable;
    }
  };

  Modal.prototype.emitModalEvents = function (eventName) {
    var event = new CustomEvent(eventName, { detail: this.selectedTrigger });
    this.element.dispatchEvent(event);
  };

  function isVisible(element) {
    return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
  };

  window.Modal = Modal;

  //initialize the Modal objects
  var modals = document.getElementsByClassName('js-modal');
  // generic focusable elements string selector
  var focusableElString = '[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary';
  if (modals.length > 0) {
    var modalArrays = [];
    for (var i = 0; i < modals.length; i++) {
      (function (i) { modalArrays.push(new Modal(modals[i])); })(i);
    }

    window.addEventListener('keydown', function (event) { //close modal window on esc
      if (event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape') {
        for (var i = 0; i < modalArrays.length; i++) {
          (function (i) { modalArrays[i].closeModal(); })(i);
        };
      }
    });
  }
}());

// wizard-form 
(function () {
  var WizardForm = function (element) {
    this.element = element;
    //this.steps = this.element.getElementsByClassName('js-wiz-form__step');
    this.steps = Array.from(this.element.getElementsByClassName('js-wiz-form__step'));

    this.currentIndex = 0;
    this.stepPrevClass = 'wiz-form__step--prev';
    this.stepNextClass = 'wiz-form__step--next';
    this.currentClass = 'js-wiz-form__step--current';
    // navigation
    this.navPrev = this.element.getElementsByClassName('js-wiz-form__prev');
    this.navNext = this.element.getElementsByClassName('js-wiz-form__next');
    this.isGoingForward = false;
    this.formSubmit = this.element.getElementsByClassName('js-wiz-form__submit');
    this.graduationButton = this.element.querySelector('.ce-graduation-selectors .button-graduation');
    this.contactLensesGraduationButton = this.element.querySelector('.button__contact-lenses-graduation');
    this.graduationButtonValues = this.element.querySelector('.button-graduation__values');
    this.readingValuesButton = this.element.querySelector('.button-reading__values');
    this.fileButton = this.element.querySelector('.ce-button-file');
    this.footerNextButton = this.element.querySelector('.ce-button-next');
    //this.inputFileLabel = this.element.querySelector('.file-upload__text').textContent;
    this.inputFileLabel = this.element.querySelector('.file-upload__text') ? this.element.querySelector('.file-upload__text').textContent : '';

    // step bar
    this.stepsBar = this.element.getElementsByClassName('js-wiz-form__step-indicator');
    if (this.stepsBar.length > 0) {
      this.stepsBarCurrent = this.stepsBar[0].getElementsByClassName('js-wiz-form__current-step');
      this.stepsBarTot = this.stepsBar[0].getElementsByClassName('js-wiz-form__tot-steps');
    }
    this.formValidatorSteps = [];
    this.pathTaken = [];
    this.selections = [];
    this.variantSelections = [];
    this.globalSku = "";
    this.globalPrice = 0;
    this.globalCheckboxPrice = 0;
    this.globalPriceWithOutAddons = 0;
    this.globalTitle = "";
    this.globalStepTitle = "";
    this.globalStepControlKey = "";
    this.globalOptionTitle = "";
    this.gesvisionValue = "";
    this.decisionTree = window.decisionTree;

    this.goToFirstStep = function () {
      this.currentIndex = 0;
      this.pathTaken = [];
      this.selections = [];
      this.variantSelections = [];
      this.globalSku = "";
      this.globalPrice = 0;
      this.globalCheckboxPrice = 0;
      this.globalPriceWithOutAddons = 0;
      this.globalTitle = "";
      this.globalStepTitle = "";
      this.globalStepControlKey = "";
      this.globalOptionTitle = "";
      this.gesvisionValue = "";

      this.steps.forEach(step => {
        step.style.transform = '';
        step.style.opacity = '';
        step.classList.remove(this.currentClass, this.stepPrevClass, this.stepNextClass);
      });

      updateForm(this);
      resetStepBar(this);
      setBarTotalSteps(this);
      updateProgressBar(this);
    };

    initWizardForm(this);
  };

  function initWizardForm(form) {
    getSelectedStep(form);
    resetNav(form);
    setupEvents(form);
    setBarTotalSteps(form);
    resetStepBar(form);
    updateProgressBar(form);
  };

  // Helper function to replace empty values with '0' for ERP compatibility
  function fillEmptyValues(obj) {
    if (typeof obj !== 'object' || obj === null) {
      return (obj === '' || obj === null || obj === undefined) ? '0' : obj;
    }
    const result = {};
    const keys = Object.keys(obj);
    // If object is empty, return default structure with '0' values
    if (keys.length === 0) {
      return { SPH: '0', CYL: '0', Axis: '0', ADD: '0', Geometry: '0', Dia: '0', Bc: '0', Quantity: '0', sku: '0' };
    }
    for (const key of keys) {
      result[key] = fillEmptyValues(obj[key]);
    }
    return result;
  }

  function setupEvents(form) {

    form.element.addEventListener('click', function (event) {
      if (event.target.closest('.js-wiz-form__next')) {
        form.isGoingForward = true;
        handleNextStep(form, event, false);
      } else if (event.target.closest('.js-wiz-form__prev')) {
        form.isGoingForward = false;
        handlePrevStep(form);
      }
    }, true);

    var radioInputs = form.element.querySelectorAll('input[type="radio"].ce-option__input');
    radioInputs.forEach(input => {
      input.addEventListener('change', function () {
        updateSelectionAppearance(input);
      });
      input.addEventListener('click', function () {
        if (input.value === 'option1') { // Si selecciona "Sin Accesorios"
          var checkboxes = form.steps[form.currentIndex].querySelectorAll('input[type="checkbox"]');
          if (checkboxes.length > 0) { // Verifica si hay checkboxes antes de desmarcarlos
            deselectCheckboxes(checkboxes);
          }
        }
        var nextButton = form.element.querySelector('.js-wiz-form__next');
        if (nextButton && !nextButton.disabled) {
          nextButton.click();
        }
      });
    });

    var checkboxInputs = form.element.querySelectorAll('input[type="checkbox"].ce-option__input');
    checkboxInputs.forEach(input => {
      input.addEventListener('change', function () {
        var label = input.closest('.ce-option');
        var checkboxPrice = parseFloat(label.getAttribute('data-addons-price'));
        var footerElements = document.querySelectorAll('#ce-multi-step .wiz-form__footer');

        if (input.value === 'option1') {
          var checkboxes = form.steps[form.currentIndex].querySelectorAll('input[type="checkbox"]:not([value="option1"])');
          if (checkboxes.length > 0) {
            deselectCheckboxes(checkboxes);
            form.navNext[0].click();
          }
        } else {
          var radioNoUpsell = form.steps[form.currentIndex].querySelector('input[value="option1"]');
          if (radioNoUpsell) {
            radioNoUpsell.checked = false;
            let radioLabel = radioNoUpsell.closest('.ce-option');
            radioLabel.classList.remove('selected');
          }
        }

        if (input.checked) {
          label.classList.add('selected');
          form.globalCheckboxPrice = form.globalCheckboxPrice + checkboxPrice;

        } else {
          label.classList.remove('selected');
          form.globalCheckboxPrice = form.globalCheckboxPrice - checkboxPrice;
        }

        var selectedOptions = form.steps[form.currentIndex].querySelectorAll('input[type="checkbox"]:checked');
        var optionLabel = input.closest('.ce-option');
        if (optionLabel) {
          var optionTitleAttr = optionLabel.getAttribute('data-option-handle');
          if (optionTitleAttr) {
            var optionTitle = optionLabel.getAttribute('data-option-handle').toLowerCase();
            var isFiltroAzulesSelected = false;
            var isSkyLensSelected = false;
            var isFotocromaticoSelected = false;

            if (optionTitle.includes('blue')) {
              isFiltroAzulesSelected = true;
            }
            if (optionTitle.includes('skylens')) {
              isSkyLensSelected = true;
            }
            if (optionTitle.includes('photochromic')) {
              isFotocromaticoSelected = true;
            }

            if (selectedOptions.length > 0 && (isFiltroAzulesSelected || isSkyLensSelected || isFotocromaticoSelected)) {
              if (footerElements.length > 0) {
                footerElements.forEach(element => {
                  element.style.backgroundColor = 'white';
                  element.style.color = 'black';
                });
              }
              Util.removeClass(document.querySelector('.next-button-wrapper'), 'hide');
            } else {
              if (footerElements.length > 0) {
                footerElements.forEach(element => {
                  element.style.backgroundColor = window.language.footerBackground;
                  element.style.color = window.language.footerColor;
                });
              }
              Util.addClass(document.querySelector('.next-button-wrapper'), 'hide');
            }
          }
        }

        if (input.classList.contains('ce-option__input--upsell')) {
          if (form.navNext[0] && !form.navNext[0].disabled) {
            form.navNext[0].click();
          }
        }

      });
    });

    function setupGraduationValidation() {
      const graduationInputs = form.element.querySelectorAll('#right-eye-sph, #right-eye-cyl, #right-eye-axis, #right-eye-add, #left-eye-sph, #left-eye-cyl, #left-eye-axis, #left-eye-add, #right-eye-pd, #left-eye-pd, #global-pd');
      const globalSwitch = form.element.querySelector('#global-switch');
      const graduationButton = form.graduationButton;

      function checkGraduationInputs() {
        let allFilled = true;

        if (globalSwitch && globalSwitch.checked) {
          // Validar los inputs de ambos ojos
          const eyeInputs = form.element.querySelectorAll('#right-eye-sph, #right-eye-cyl, #right-eye-axis, #right-eye-add, #left-eye-sph, #left-eye-cyl, #left-eye-axis, #left-eye-add, #right-eye-pd, #left-eye-pd');
          eyeInputs.forEach(input => {
            if (input.value === '') {
              allFilled = false;
            }
          });
        } else {
          // Validar los inputs globales y los inputs de ambos ojos
          const eyeInputs = form.element.querySelectorAll('#right-eye-sph, #right-eye-cyl, #right-eye-axis, #right-eye-add, #left-eye-sph, #left-eye-cyl, #left-eye-axis, #left-eye-add, #global-pd');
          eyeInputs.forEach(input => {
            if (input.value === '') {
              allFilled = false;
            }
          });
        }

        graduationButton.disabled = !allFilled;
      }

      graduationInputs.forEach(input => {
        input.addEventListener('input', checkGraduationInputs);
      });

      if (graduationInputs.length > 0) {
        checkGraduationInputs();
      }

      // Validar inicialmente según el estado del switch
      if (globalSwitch) {
        globalSwitch.addEventListener('change', checkGraduationInputs);
      }
    }

    function setupPdValidation() {
      const globalSwitch = document.getElementById('global-switch');
      const globalPdWrapper = document.getElementById('global-pd-wrapper');
      const rightEyePdWrapper = document.getElementById('right-eye-pd-wrapper');
      const leftEyePdWrapper = document.getElementById('left-eye-pd-wrapper');

      if (!globalSwitch || !globalPdWrapper || !rightEyePdWrapper || !leftEyePdWrapper) {
        return;
      }

      globalSwitch.addEventListener('change', function () {
        if (globalSwitch.checked) {
          globalPdWrapper.style.display = 'none';
          rightEyePdWrapper.style.display = 'block';
          leftEyePdWrapper.style.display = 'block';
        } else {
          globalPdWrapper.style.display = 'block';
          rightEyePdWrapper.style.display = 'none';
          leftEyePdWrapper.style.display = 'none';
        }
      });

      // Initial state based on switch status
      if (globalSwitch.checked) {
        globalPdWrapper.style.display = 'none';
        rightEyePdWrapper.style.display = 'block';
        leftEyePdWrapper.style.display = 'block';
      } else {
        globalPdWrapper.style.display = 'block';
        rightEyePdWrapper.style.display = 'none';
        leftEyePdWrapper.style.display = 'none';
      }
    }

    function handleContactLensVariants(form) {
      const contactLensVariants = document.querySelectorAll('label[data-gesvision-value="contact_lenses_variants"] input[type="radio"]');

      if (contactLensVariants && contactLensVariants.length > 0) {
        const visibleVariants = Array.from(contactLensVariants).filter(option => {
          const parentLabel = option.closest('label');
          return parentLabel && !parentLabel.classList.contains('hide');
        });

        if (visibleVariants.length > 0) {
          if (visibleVariants.length === 1) {
            visibleVariants[0].checked = true;

            const event = new Event('change');
            visibleVariants[0].dispatchEvent(event);

            const nextButton = form.navNext[0];

            if (nextButton && !nextButton.disabled) {
              nextButton.click();
            }
          }
        }
      }
    }

    var readingInputs = form.element.querySelectorAll('input[name="magnification"]');
    readingInputs.forEach(input => {
      input.addEventListener('change', function (event) {
        event.preventDefault();
        //form.navNext[0].click();
        form.readingValuesButton.removeAttribute('disabled');
      });
    });

    if (form.formSubmit.length > 0) {
      form.formSubmit[0].addEventListener('click', function (event) {
        event.preventDefault();
        addMultipleProducts(form.variantSelections, event);
      });
    }

    if (form.graduationButton) {
      form.graduationButton.addEventListener('click', function (event) {
        event.preventDefault();
        form.navNext[0].click();
      });
    }

    if (form.contactLensesGraduationButton) {
      form.contactLensesGraduationButton.addEventListener('click', function (event) {
        event.preventDefault();
        form.navNext[0].click();
      });
    }

    if (form.graduationButtonValues) {
      form.graduationButtonValues.addEventListener('click', function (event) {
        event.preventDefault();
        form.navNext[0].click();
      });
    }

    if (form.fileButton) {
      form.fileButton.addEventListener('click', function (event) {
        event.preventDefault();
        form.navNext[0].click();
      });
    }

    if (form.readingValuesButton) {
      form.readingValuesButton.addEventListener('click', function (event) {
        event.preventDefault();
        form.navNext[0].click();
      });
    }

    if (form.footerNextButton) {
      form.footerNextButton.addEventListener('click', function (event) {
        event.preventDefault();
        form.navNext[0].click();
      });
    }

    setupGraduationValidation();
    setupPdValidation();
    handleContactLensVariants(form);

  };

  function addMainProductWithFile(mainProduct, file) {
    const data = new FormData();
    Object.keys(mainProduct.properties).forEach(key => {
      data.append(`properties[${key}]`, mainProduct.properties[key]);
    });
    data.append("properties[file]", file);
    data.append("id", mainProduct.id);
    data.append("quantity", mainProduct.quantity);


    return fetch("/cart/add.js", {
      method: "POST",
      body: data
    }).then(response => {
      if (!response.ok) {
        throw new Error(`Error adding main product: ${response.statusText}`);
      }
      return response.json();
    });
  };

  function deselectCheckboxes(checkboxes) {
    checkboxes.forEach(checkbox => {
      let radioLabel = checkbox.closest('.ce-option');
      checkbox.checked = false;
      radioLabel.classList.remove('selected');
    });
  }

  function updateSelectionAppearance(input) {
    if (input.checked) {
      let allRadios = input.closest('.wiz-form__step').querySelectorAll('.ce-option');
      allRadios.forEach(radio => {
        radio.classList.remove('selected');
      });
      input.closest('.ce-option').classList.add('selected');
    }
  }

  function addMultipleProducts(variantSelections, event) {
    //formSubmit = event.target.closest('.js-wiz-form__submit');
    //formSubmit.classList.add('loading');
    var buttonAddToCart = event.target.closest('.js-wiz-form__submit');
    var buttonLoader = buttonAddToCart.querySelector('.circle-loader');
    buttonLoader.style.display = 'inline-block';
    var groupId = Date.now();

    var mainProduct = {
      id: null,
      quantity: 1,
      properties: {}
    };

    var itemsToAdd = [];
    var totalGroupPrice = 0;

    Object.entries(variantSelections)
      .sort(([keyA], [keyB]) => {
        if (keyA === 'main') return -1; // main siempre primero
        if (keyB === 'main') return 1;

        const isAddonA = keyA.startsWith('addon-');
        const isAddonB = keyB.startsWith('addon-');

        const isUpsellA = keyA.startsWith('upsell-');
        const isUpsellB = keyB.startsWith('upsell-');

        // Asegurar que upsells estén antes que addons
        if (isUpsellA && !isUpsellB) return -1;
        if (!isUpsellA && isUpsellB) return 1;
        if (isAddonA && !isAddonB) return 1;
        if (!isAddonA && isAddonB) return -1;

        // Si ambos son addons o upsells, ordenar por índice
        const indexA = parseInt(keyA.split('-')[1]);
        const indexB = parseInt(keyB.split('-')[1]);
        return indexA - indexB;
      })
      .forEach(([key, variant], index) => {
        let properties = {
          "_p_productType": key.includes('main') ? 'main' : (key.includes('addon-') ? 'addon' : 'upsell'),
          "_p_mainProductSKU": variant.sku,
          "_p_groupId": "group-" + groupId
        };

        if (key.includes('main')) {
          mainProduct.id = variant.id;

          let totalQuantity = variant.quantity;
          variant.props.forEach(prop => {
            if (prop.hasOwnProperty('contact_lenses_prescription')) {
              const prescription = JSON.parse(prop['contact_lenses_prescription']);
              let leftEyeQuantity = prescription.leftEye && prescription.leftEye.Quantity ? parseInt(prescription.leftEye.Quantity) : 0;
              let rightEyeQuantity = prescription.rightEye && prescription.rightEye.Quantity ? parseInt(prescription.rightEye.Quantity) : 0;
              totalQuantity = leftEyeQuantity + rightEyeQuantity;
            }
          });

          mainProduct.quantity = totalQuantity;
          totalGroupPrice += parseFloat(variant.priceWithOutAddons) * mainProduct.quantity;

          variant.props.forEach(addon => {
            for (let [addonKey, addonValue] of Object.entries(addon)) {
              if (addonValue !== 'no_value' && addonKey !== 'contact_lenses_variants') {
                if (addonKey.startsWith('gesvision')) {
                  properties[`_p_${addonKey}`] = addonValue;
                } else {
                  properties[`_${addonKey}`] = addonValue;
                }
              }
            };
          });

          if (variant.image) {
            properties['_p_productImage'] = variant.image;
          }
          mainProduct.properties = properties;
        } else if (key.includes('addon-')) {
          totalGroupPrice += parseFloat(variant.priceBackup) * variant.quantity;
          variant.ids.forEach(addonId => {
            itemsToAdd.push({
              id: addonId,
              quantity: variant.quantity,
              properties: properties
            });
          });
        } else {
          itemsToAdd.push({
            id: variant.id,
            quantity: variant.quantity,
            properties: properties
          });
        }
      });

    mainProduct.properties['_p_groupPrice'] = totalGroupPrice;
    itemsToAdd = itemsToAdd.filter(item => item !== undefined);
    //itemsToAdd = [mainProduct, ...itemsToAdd.filter(item => item !== undefined)];

    console.log('itemsToAdd', itemsToAdd.concat(mainProduct));

    const fileInput = document.querySelector('.file-upload__input');
    const file = fileInput ? fileInput.files[0] : null;

    function resetFileInput() {
      if (fileInput) {
        fileInput.value = '';
      }
    }

    function handleCartError(errors) {
      if (Array.isArray(errors)) {
        errors.forEach(errorArray => {
          if (Array.isArray(errorArray)) {
            errorArray.forEach(errorMessage => {
              alert(errorMessage);
              console.log(errorMessage);
            });
          } else {
            alert(errorArray);
            console.log(errorArray);
          }
        });
      } else {
        alert(errors);
        console.log(errors);
      }
    }

    if (file && mainProduct.id) {

      // Subir primero los upsells y addons
      if (itemsToAdd.length > 0) {

        CartJS.addItems(itemsToAdd, {
          "success": function (data, textStatus, jqXHR) {
            addMainProductWithFile(mainProduct, file)
              .then(() => {
                CartJS.getCart({
                  success: function (cart) {
                    $(document).on('cart.requestComplete', function (event, cart) {
                      window.multiStepDrawer.closeDrawer();
                      buttonLoader.style.display = 'none';
                      const cartUpdateEvent = new CustomEvent("cart:update", {
                        bubbles: true,
                        detail: {
                          resource: null,
                          sourceId: 'multi-step-form',
                          data: {
                            source: 'multi-step-form',
                            itemCount: 0,
                            sections: {}
                          }
                        }
                      });
                      document.dispatchEvent(cartUpdateEvent);
                      setTimeout(() => {
                        const cartDrawer = document.querySelector('cart-drawer-component');
                        if (cartDrawer && typeof cartDrawer.open === 'function') {
                          cartDrawer.open();
                        }
                        const removeButtons = document.querySelectorAll('.ce-remove-button__wrapper .ce-remove-button');
                        if (removeButtons.length > 0) {
                          removeButtons.forEach(button => {
                            button.addEventListener('click', customRemoveWithAddons);
                          });
                        }
                      }, 400);

                    });
                    resetFileInput();
                  },
                  error: function (error) {
                    console.error('Error fetching cart:', error);
                    buttonLoader.style.display = 'none';
                    resetFileInput();
                  }
                });
              })
              .catch(error => {
                console.error('Error adding main product with file:', error);
                buttonLoader.style.display = 'none';
                resetFileInput();
              });
          },
          "error": function (jqXHR, textStatus, errorThrown) {
            buttonLoader.style.display = 'none';
            const errors = jqXHR.responseJSON.description;
            handleCartError(errors);
            resetFileInput();
          }
        });

      } else {

        // Si no hay upsells/addons, solo agregamos el mainProduct con el archivo
        addMainProductWithFile(mainProduct, file)
          .then(() => {
            CartJS.getCart({
              success: function (cart) {
                $(document).on('cart.requestComplete', function (event, cart) {
                  window.multiStepDrawer.closeDrawer();
                  buttonLoader.style.display = 'none';
                  const cartUpdateEvent = new CustomEvent("cart:update", {
                    bubbles: true,
                    detail: {
                      resource: null,
                      sourceId: 'multi-step-form',
                      data: {
                        source: 'multi-step-form',
                        itemCount: 0,
                        sections: {}
                      }
                    }
                  });
                  document.dispatchEvent(cartUpdateEvent);
                  setTimeout(() => {
                    const cartDrawer = document.querySelector('cart-drawer-component');
                    if (cartDrawer && typeof cartDrawer.open === 'function') {
                      cartDrawer.open();
                    }
                    const removeButtons = document.querySelectorAll('.ce-remove-button__wrapper .ce-remove-button');
                    if (removeButtons.length > 0) {
                      removeButtons.forEach(button => {
                        button.addEventListener('click', customRemoveWithAddons);
                      });
                    }
                  }, 400);
                });
                resetFileInput();
              },
              error: function (error) {
                console.error('Error fetching cart:', error);
                buttonLoader.style.display = 'none';
                resetFileInput();
              }
            });
          })
          .catch(error => {
            console.error('Error adding main product with file:', error);
            buttonLoader.style.display = 'none';
            resetFileInput();
          });

      }

    } else {

      CartJS.addItems(itemsToAdd.concat(mainProduct), {
        "success": function (data, textStatus, jqXHR) {
          $(document).on('cart.requestComplete', function (event, cart) {
            window.multiStepDrawer.closeDrawer();
            buttonLoader.style.display = 'none';
            const cartUpdateEvent = new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                resource: null,
                sourceId: 'multi-step-form',
                data: {
                  source: 'multi-step-form',
                  itemCount: 0,
                  sections: {}
                }
              }
            });
            document.dispatchEvent(cartUpdateEvent);
            setTimeout(() => {
              const cartDrawer = document.querySelector('cart-drawer-component');
              if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              }
              resetFileInput();
              const removeButtons = document.querySelectorAll('.ce-remove-button__wrapper .ce-remove-button');
              if (removeButtons.length > 0) {
                removeButtons.forEach(button => {
                  button.addEventListener('click', customRemoveWithAddons);
                });
              }
            }, 400);
          });
        },
        "error": function (jqXHR, textStatus, errorThrown) {
          buttonLoader.style.display = 'none';
          const errors = jqXHR.responseJSON.description;
          handleCartError(errors);
          resetFileInput();
        }
      });
    }

  };

  function handleNextStep(form, event) {

    form.globalStepTitle = form.steps[form.currentIndex].getAttribute('data-step-title');
    var selectedOption = form.steps[form.currentIndex].querySelector('input[type="radio"].ce-option__input:checked');

    var selectedCheckboxes = form.steps[form.currentIndex].querySelectorAll('input[type="checkbox"]:checked');

    var fileInput = form.steps[form.currentIndex].querySelector('input[type="file"].js-file-upload');
    var fileSelected = fileInput && fileInput.files.length > 0;

    var graduationSelectors = form.steps[form.currentIndex].querySelector('[data-option-type="graduation-selectors"]');
    var readingValuesOption = form.steps[form.currentIndex].querySelector('[data-option-type="reading-values"]');

    var contactLensesGraduation = form.steps[form.currentIndex].querySelector('[data-option-type="contactlenses_graduation"]');

    form.globalStepControlKey = form.steps[form.currentIndex].getAttribute('data-step-control-key');
    var autoSelectedLensVariant = document.querySelector('label[data-gesvision-value="contact_lenses_variants"] input[type="radio"]:checked');

    var globalSwitch = form.steps[form.currentIndex].querySelector('#global-switch');
    var globalPd = form.steps[form.currentIndex].querySelector('#global-pd');
    var rightEyeSPH = form.steps[form.currentIndex].querySelector('#right-eye-sph');
    var rightEyeCYL = form.steps[form.currentIndex].querySelector('#right-eye-cyl');
    var rightEyeAxis = form.steps[form.currentIndex].querySelector('#right-eye-axis');
    var rightEyeAdd = form.steps[form.currentIndex].querySelector('#right-eye-add');
    var leftEyeSPH = form.steps[form.currentIndex].querySelector('#left-eye-sph');
    var leftEyeCYL = form.steps[form.currentIndex].querySelector('#left-eye-cyl');
    var leftEyeAxis = form.steps[form.currentIndex].querySelector('#left-eye-axis');
    var leftEyeAdd = form.steps[form.currentIndex].querySelector('#left-eye-add');
    var rightEyePD = form.steps[form.currentIndex].querySelector('#right-eye-pd');
    var leftEyePD = form.steps[form.currentIndex].querySelector('#left-eye-pd');

    function checkGraduationValues() {
      if (globalSwitch && globalSwitch.checked) {
        return (
          (rightEyeSPH && rightEyeSPH.value !== "") &&
          (rightEyeCYL && rightEyeCYL.value !== "") &&
          (rightEyeAxis && rightEyeAxis.value !== "") &&
          (rightEyeAdd && rightEyeAdd.value !== "") &&
          (leftEyeSPH && leftEyeSPH.value !== "") &&
          (leftEyeCYL && leftEyeCYL.value !== "") &&
          (leftEyeAxis && leftEyeAxis.value !== "") &&
          (leftEyeAdd && leftEyeAdd.value !== "") &&
          (rightEyePD && rightEyePD.value !== "") &&
          (leftEyePD && leftEyePD.value !== "")
        );
      } else {
        return (
          (rightEyeSPH && rightEyeSPH.value !== "") &&
          (rightEyeCYL && rightEyeCYL.value !== "") &&
          (rightEyeAxis && rightEyeAxis.value !== "") &&
          (rightEyeAdd && rightEyeAdd.value !== "") &&
          (leftEyeSPH && leftEyeSPH.value !== "") &&
          (leftEyeCYL && leftEyeCYL.value !== "") &&
          (leftEyeAxis && leftEyeAxis.value !== "") &&
          (leftEyeAdd && leftEyeAdd.value !== "") &&
          (globalPd && globalPd.value !== "")
        );
      }
    }
    var hasGraduationValues = checkGraduationValues();

    function checkReadingValues() {
      const readingInputs = document.querySelectorAll('input[name="magnification"]');
      let isAnyReadingValueSelected = false;
      readingInputs.forEach(input => {
        if (input.checked) {
          isAnyReadingValueSelected = true;
        }
      });
      return isAnyReadingValueSelected;
    }
    var hasReadingValues = checkReadingValues();

    // Obtener los selectores del DOM para ambos ojos en LENTILLAS
    const sphLeftSelect = document.getElementById('sph-left');
    const sphRightSelect = document.getElementById('sph-right');
    const cylLeftSelect = document.getElementById('cyl-left');
    const cylRightSelect = document.getElementById('cyl-right');
    const axisLeftSelect = document.getElementById('axis-left');
    const axisRightSelect = document.getElementById('axis-right');
    const addLeftSelect = document.getElementById('add-left');
    const addRightSelect = document.getElementById('add-right');
    const geometryLeftSelect = document.getElementById('geometry-left');
    const geometryRightSelect = document.getElementById('geometry-right');
    const diameterLeftSelect = document.getElementById('diameter-left');
    const diameterRightSelect = document.getElementById('diameter-right');
    const curvatureLeftSelect = document.getElementById('curvature-left');
    const curvatureRightSelect = document.getElementById('curvature-right');
    const quantityLeftSelect = document.getElementById('quantity-left');
    const quantityRightSelect = document.getElementById('quantity-right');
    const leftEyeCheckbox = document.querySelector('.checkbox-control input[name="left-eye-checkbox"]');
    const rightEyeCheckbox = document.querySelector('.checkbox-control input[name="right-eye-checkbox"]');

    function validateContactLensesGraduation() {

      const leftEyeSelected = leftEyeCheckbox ? leftEyeCheckbox.checked : false;
      const rightEyeSelected = rightEyeCheckbox ? rightEyeCheckbox.checked : false;

      const leftEyeValid = leftEyeSelected && (
        (!sphLeftSelect || sphLeftSelect.value !== "") &&
        (!cylLeftSelect || cylLeftSelect.value !== "") &&
        (!axisLeftSelect || axisLeftSelect.value !== "") &&
        (!addLeftSelect || addLeftSelect.value !== "") &&
        (!diameterLeftSelect || diameterLeftSelect.value !== "") &&
        (!curvatureLeftSelect || curvatureLeftSelect.value !== "") &&
        (quantityLeftSelect && quantityLeftSelect.value !== "")
      );

      const rightEyeValid = rightEyeSelected && (
        (!sphRightSelect || sphRightSelect.value !== "") &&
        (!cylRightSelect || cylRightSelect.value !== "") &&
        (!axisRightSelect || axisRightSelect.value !== "") &&
        (!addRightSelect || addRightSelect.value !== "") &&
        (!diameterRightSelect || diameterRightSelect.value !== "") &&
        (!curvatureRightSelect || curvatureRightSelect.value !== "") &&
        (quantityRightSelect && quantityRightSelect.value !== "")
      );

      if (leftEyeSelected && !leftEyeValid) {
        updateGraduationButtonState(false);
        return false;
      }

      if (rightEyeSelected && !rightEyeValid) {
        updateGraduationButtonState(false);
        return false;
      }

      const isValid = leftEyeSelected || rightEyeSelected;
      updateGraduationButtonState(isValid);
      return isValid;
    }
    var hasContactLensesValues = validateContactLensesGraduation();

    [
      sphLeftSelect, cylLeftSelect, axisLeftSelect, addLeftSelect, diameterLeftSelect, curvatureLeftSelect, quantityLeftSelect,
      sphRightSelect, cylRightSelect, axisRightSelect, addRightSelect, diameterRightSelect, curvatureRightSelect, quantityRightSelect,
      leftEyeCheckbox, rightEyeCheckbox
    ].forEach(element => {
      if (element) {
        element.removeEventListener('change', validateContactLensesGraduation);
        element.addEventListener('change', validateContactLensesGraduation);
      }
    });

    function updateGraduationButtonState(isEnabled) {
      const graduationButton = document.querySelector('.button__contact-lenses-graduation');
      if (graduationButton) {
        graduationButton.disabled = !isEnabled;
      }
    }

    //filters validation
    var selectedOptions = form.steps[form.currentIndex].querySelectorAll('input[type="checkbox"]:checked');
    var isFiltroAzulesSelected = false;
    var isSkyLensSelected = false;
    var isFotocromaticoSelected = false;

    selectedOptions.forEach(function (option) {
      var optionLabel = option.closest('.ce-option');
      if (optionLabel) {
        var optionTitleAttr = optionLabel.getAttribute('data-option-handle');
        if (optionTitleAttr) {
          var optionTitle = optionLabel.getAttribute('data-option-handle').toLowerCase();
          if (optionTitle.includes('blue')) {
            isFiltroAzulesSelected = true;
          }
          if (optionTitle.includes('skylens')) {
            isSkyLensSelected = true;
          }
          if (optionTitle.includes('photochromic')) {
            isFotocromaticoSelected = true;
          }
        }
      }
    });

    var dataOptionElement = form.steps[form.currentIndex].querySelector('[data-option-value]');
    var dataOptionValue = dataOptionElement ? dataOptionElement.getAttribute('data-option-value') : null;

    if (fileInput && !fileSelected) {
      alert(window.language.fileUploadRequired);
      hideSubmitButton(form);
      return;
    }

    if (graduationSelectors && !hasGraduationValues) {
      alert(window.language.graduationValuesRequired);
      hideSubmitButton(form);
      return;
    }

    if (readingValuesOption && !hasReadingValues) {
      alert(window.language.readingValuesRequired);
      hideSubmitButton(form);
      return;
    }

    if (contactLensesGraduation && !hasContactLensesValues) {
      alert(window.language.contactLensesValuesRequired);
      hideSubmitButton(form);
      return;
    }

    if (!selectedOption && selectedCheckboxes.length === 0 && !dataOptionValue && (!autoSelectedLensVariant || autoSelectedLensVariant.length === 0)) {
      if (form.globalStepControlKey !== 'accesories') {
        alert(window.language.selectOption);
        hideSubmitButton(form);
        return;
      }
    }

    // Regla 4: Filtro de azules + SkyLens + Fotocromático - No permitido
    if (isFiltroAzulesSelected && isSkyLensSelected && isFotocromaticoSelected) {
      alert(window.language.keyPhotocromic);
      return;
    }

    // Regla 3: Filtro de azules + Fotocromático - No permitido (sin SkyLens)
    if (isFiltroAzulesSelected && isFotocromaticoSelected && !isSkyLensSelected) {
      alert(window.language.keySkyLens);
      return;
    }

    var selectedOptionLabel = selectedOption ? selectedOption.closest('.ce-option') : null;
    var currentId = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-current-id') : null;
    form.globalTitle = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-current-title') : null;
    var currentPrice = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-current-price') : 0;
    var currentSku = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-current-sku') : null;
    var currentProductImage = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-current-image') : null;

    var alternativeId = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-alternative-id') : null;
    var alternativePrice = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-alternative-price') : null;
    var alternativeSku = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-alternative-sku') : null;

    var addOnId = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-addon-id') : null;
    var addOnPrice = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-addon-price') : null;

    var addonsIds = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-addons-ids') : null;
    var addonsPrice = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-addons-price') : 0;
    var addonsPriceBackup = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-addons-price-backup') : 0;
    var addonQuantity = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-addon-quantity') : 1;

    //var stepTitle = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-step-title') : null;
    var optionTitle = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-option-title') : null;
    form.globalOptionTitle = optionTitle;

    var selectedValue = selectedOption ? selectedOption.value : (fileSelected ? fileInput.getAttribute('data-option-value') : (dataOptionElement ? dataOptionElement.getAttribute('data-option-value') : 'option2'));

    var addonsOnFirstStep = !!selectedOptionLabel && selectedOptionLabel.getAttribute('data-addons-on-first-step') === "true";

    //form.gesvisionValue = selectedOptionLabel ? selectedOptionLabel.getAttribute('data-gesvision-value') : null;
    form.gesvisionValue = selectedOptionLabel
      ? selectedOptionLabel.getAttribute('data-gesvision-value')
      : (dataOptionElement
        ? dataOptionElement.getAttribute('data-gesvision-value')
        : null);

    var optionTitles = [];

    let graduationValues;
    if (globalSwitch && globalSwitch.checked) {
      // Validar los valores específicos de cada ojo
      graduationValues = {
        rightEye: {
          SPH: rightEyeSPH ? rightEyeSPH.value : '',
          CYL: rightEyeCYL ? rightEyeCYL.value : '',
          Axis: rightEyeAxis ? rightEyeAxis.value : '',
          Add: rightEyeAdd ? rightEyeAdd.value : '',
          PD: rightEyePD ? rightEyePD.value : ''
        },
        leftEye: {
          SPH: leftEyeSPH ? leftEyeSPH.value : '',
          CYL: leftEyeCYL ? leftEyeCYL.value : '',
          Axis: leftEyeAxis ? leftEyeAxis.value : '',
          Add: leftEyeAdd ? leftEyeAdd.value : '',
          PD: leftEyePD ? leftEyePD.value : ''
        }
      };
    } else {
      // Validar el valor global
      graduationValues = {
        rightEye: {
          SPH: rightEyeSPH ? rightEyeSPH.value : '',
          CYL: rightEyeCYL ? rightEyeCYL.value : '',
          Axis: rightEyeAxis ? rightEyeAxis.value : '',
          Add: rightEyeAdd ? rightEyeAdd.value : '',
          PD: globalPd ? globalPd.value : ''
        },
        leftEye: {
          SPH: leftEyeSPH ? leftEyeSPH.value : '',
          CYL: leftEyeCYL ? leftEyeCYL.value : '',
          Axis: leftEyeAxis ? leftEyeAxis.value : '',
          Add: leftEyeAdd ? leftEyeAdd.value : '',
          PD: globalPd ? globalPd.value : ''
        }
      };
    }

    /*lentillas*/
    const fabricationDetails = document.getElementById('fabrication-details');
    let parsedFabricationDetails = null;
    if (fabricationDetails) {
      parsedFabricationDetails = JSON.parse(fabricationDetails.textContent);
    } else {
      parsedFabricationDetails = null;
    }

    // Función para encontrar el SKU basado en los valores seleccionados
    function findMatchingSku(eyeValues, fabricationDetails) {
      if (!fabricationDetails || !eyeValues) return null;

      // Helper: compara solo si ambos valores existen y son válidos
      const matchField = (userValue, itemValue) => {
        if (userValue === '' || userValue === null || userValue === undefined) return true;
        if (itemValue === undefined || itemValue === null) return true;
        return parseFloat(userValue) === itemValue;
      };

      // ADD y Geometry vienen de metafields, no del fabrication_details, por eso no se comparan
      const result = fabricationDetails.find(item => {
        return matchField(eyeValues.SPH, item.esfera) &&
          matchField(eyeValues.CYL, item.cilindro) &&
          matchField(eyeValues.Axis, item.eje) &&
          matchField(eyeValues.Dia, item.diametro) &&
          matchField(eyeValues.Bc, item.curvaBase);
      });

      // DEBUG: Verificar búsqueda de SKU en lentillas
      console.log('[DEBUG findMatchingSku]', {
        userValues: eyeValues,
        foundItem: result || 'NO MATCH',
        sku: result?.sku || null
      });

      return result?.sku || null;
    }

    // Guardar los valores de graduación de lentillas
    let contactLensValues = {};

    if (parsedFabricationDetails) {

      if (leftEyeCheckbox && leftEyeCheckbox.checked) {
        contactLensValues.leftEye = {
          SPH: sphLeftSelect && sphLeftSelect.value ? sphLeftSelect.value : '',
          CYL: cylLeftSelect && cylLeftSelect.value ? cylLeftSelect.value : '',
          Axis: axisLeftSelect && axisLeftSelect.value ? axisLeftSelect.value : '',
          ADD: addLeftSelect && addLeftSelect.value ? addLeftSelect.value : '',
          Geometry: geometryLeftSelect && geometryLeftSelect.value ? geometryLeftSelect.value : '',
          Dia: diameterLeftSelect && diameterLeftSelect.value ? diameterLeftSelect.value : '',
          Bc: curvatureLeftSelect && curvatureLeftSelect.value ? curvatureLeftSelect.value : '',
          Quantity: quantityLeftSelect && quantityLeftSelect.value ? quantityLeftSelect.value : ''
        };
        const leftEyeSku = findMatchingSku(contactLensValues.leftEye, parsedFabricationDetails);
        if (leftEyeSku) {
          contactLensValues.leftEye.sku = leftEyeSku;
        }
      }

      if (rightEyeCheckbox && rightEyeCheckbox.checked) {
        contactLensValues.rightEye = {
          SPH: sphRightSelect && sphRightSelect.value ? sphRightSelect.value : '',
          CYL: cylRightSelect && cylRightSelect.value ? cylRightSelect.value : '',
          Axis: axisRightSelect && axisRightSelect.value ? axisRightSelect.value : '',
          ADD: addRightSelect && addRightSelect.value ? addRightSelect.value : '',
          Geometry: geometryRightSelect && geometryRightSelect.value ? geometryRightSelect.value : '',
          Dia: diameterRightSelect && diameterRightSelect.value ? diameterRightSelect.value : '',
          Bc: curvatureRightSelect && curvatureRightSelect.value ? curvatureRightSelect.value : '',
          Quantity: quantityRightSelect && quantityRightSelect.value ? quantityRightSelect.value : ''
        };
        const rightEyeSku = findMatchingSku(contactLensValues.rightEye, parsedFabricationDetails);
        if (rightEyeSku) {
          contactLensValues.rightEye.sku = rightEyeSku;
        }
      }
    }

    if (form.currentIndex === 0 && alternativeId) {
      form.globalSku = alternativeSku
      alternativePrice = parseFloat(alternativePrice) || 0;
      addonsPrice = parseFloat(addonsPrice) || 0;
      form.globalPrice = parseFloat(alternativePrice) + parseFloat(addonsPrice)
      form.globalPriceWithOutAddons = parseFloat(alternativePrice);

      //form.globalPrice = Math.ceil(form.globalPrice)
      form.variantSelections['main'] = {
        id: alternativeId,
        title: form.globalTitle.trim(),
        price: form.globalPrice,
        priceWithOutAddons: form.globalPriceWithOutAddons,
        quantity: 1,
        sku: form.globalSku,
        image: currentProductImage,
        props: []
      };
    } else if (form.currentIndex === 0) {
      form.globalSku = currentSku
      currentPrice = parseFloat(currentPrice) || 0;
      addonsPrice = parseFloat(addonsPrice) || 0;
      form.globalPrice = parseFloat(currentPrice) + parseFloat(addonsPrice)
      form.globalPriceWithOutAddons = parseFloat(currentPrice);

      //form.globalPrice = Math.ceil(form.globalPrice)
      form.globalOptionTitle = optionTitle.trim();
      form.variantSelections['main'] = {
        id: currentId,
        title: form.globalTitle.trim(),
        price: form.globalPrice,
        priceWithOutAddons: form.globalPriceWithOutAddons,
        quantity: 1,
        sku: form.globalSku,
        image: currentProductImage,
        props: []
      };
    }

    resetAddOnsAndUpsellsFromStep(form, form.currentIndex);

    // Handle checkbox selections
    var selectedCheckboxes = form.steps[form.currentIndex].querySelectorAll('input[type="checkbox"]:checked');

    if (selectedCheckboxes.length > 0) {
      selectedCheckboxes.forEach((checkbox, index) => {
        if (checkbox.classList.contains('ce-option__input--upsell')) {
          var checkboxLabel = checkbox.closest('.ce-option-upsell');
          var checkboxUpsellTitle = checkboxLabel.getAttribute('data-upsell-title');
          var checkboxUpsellId = checkboxLabel.getAttribute('data-upsell-id');
          var checkboxUpsellPrice = checkboxLabel.getAttribute('data-upsell-price');
          form.variantSelections['upsell-' + index] = {
            id: checkboxUpsellId,
            title: checkboxUpsellTitle,
            price: parseFloat(checkboxUpsellPrice),
            quantity: 1,
            sku: form.globalSku
          };
        } else if (checkbox.classList.contains('ce-option__checkbox--basic')) {
          var checkboxLabel = checkbox.closest('.ce-option');
          var checkboxAddonsIds = checkboxLabel.getAttribute('data-addons-ids');
          var checkboxAddonsPrice = checkboxLabel.getAttribute('data-addons-price');
          var checkboxAddonsPriceBackup = checkboxLabel.getAttribute('data-addons-price-backup');
          var checkboxAddonTitle = checkboxLabel.getAttribute('data-option-title');
          var checkboxAddonQuantity = checkboxLabel.getAttribute('data-addon-quantity');
          if (checkboxAddonsIds) {
            form.variantSelections['addon-' + form.currentIndex + '-' + index] = {
              ids: checkboxAddonsIds.split(','),
              title: checkboxAddonTitle,
              price: parseFloat(checkboxAddonsPrice),
              priceBackup: parseFloat(checkboxAddonsPriceBackup),
              quantity: checkboxAddonQuantity,
              sku: form.globalSku
            };

            if (checkboxAddonTitle) {
              let formattedOptionTitle = checkboxAddonTitle;
              if (checkboxAddonsPrice) {
                let numericAddOnPrice = parseFloat(checkboxAddonsPrice);
                if (!isNaN(numericAddOnPrice) && numericAddOnPrice != null) {
                  let addOnPriceFormatted = numericAddOnPrice / 100;
                  //formattedOptionTitle += `  +${addOnPriceFormatted}window.language.c€ountryCurrency`;
                  formattedOptionTitle;
                }
              }
              optionTitles.push(formattedOptionTitle);
            }

          }
        }
      });
    } else {
      if (addonsIds && form.currentIndex >= 1) {
        form.variantSelections['addon-' + form.currentIndex] = {
          ids: addonsIds.split(','),
          title: optionTitle,
          price: parseFloat(addonsPrice),
          priceBackup: parseFloat(addonsPriceBackup),
          quantity: addonQuantity,
          sku: form.globalSku
        };
        let formattedOptionTitle = form.globalOptionTitle;
        if (addonsPrice) {
          let numericAddOnPrice = parseFloat(addonsPrice);
          if (!isNaN(numericAddOnPrice) && numericAddOnPrice != null) {
            let addOnPriceFormatted = numericAddOnPrice / 100;
            //formattedOptionTitle += `  +${addOnPriceFormatted}${window.language.countryCurrency}`;
            formattedOptionTitle;
          }
          optionTitles.push(formattedOptionTitle);
        }
      } else if (addonsIds && form.currentIndex == 0 && addonsOnFirstStep) {
        form.variantSelections['addon-' + form.currentIndex] = {
          ids: addonsIds.split(','),
          title: optionTitle,
          price: parseFloat(addonsPrice),
          priceBackup: parseFloat(addonsPriceBackup),
          quantity: addonQuantity,
          sku: form.globalSku
        };
        let formattedOptionTitle = form.globalOptionTitle;
        if (addonsPrice) {
          let numericAddOnPrice = parseFloat(addonsPrice);
          if (!isNaN(numericAddOnPrice) && numericAddOnPrice != null) {
            let addOnPriceFormatted = numericAddOnPrice / 100;
            //formattedOptionTitle += `  +${addOnPriceFormatted}${window.language.countryCurrency}`;
            formattedOptionTitle;
          }
          optionTitles.push(formattedOptionTitle);
        }
      } else {
        if (form.globalOptionTitle) {
          optionTitles.push(form.globalOptionTitle);
        }
      }
    }

    // Obtener nextSteps
    var nextSteps = form.decisionTree[form.currentIndex + 1];
    var isNextStepFinal = nextSteps && Object.values(nextSteps).every(value => value === null);

    if (!isNextStepFinal && form.globalStepTitle && optionTitles.length > 0) {
      form.variantSelections['main'].props.push({
        [form.globalStepTitle]: optionTitles.join(', ')
      });
    }

    if (!isNextStepFinal && form.globalStepTitle && hasGraduationValues) {
      form.variantSelections['main'].props.push({
        [form.gesvisionValue]: JSON.stringify(fillEmptyValues(graduationValues))
      });
    }

    if (!isNextStepFinal && form.globalStepTitle && hasContactLensesValues) {
      form.variantSelections['main'].props.push({
        [form.gesvisionValue]: JSON.stringify(fillEmptyValues(contactLensValues))
      });
    }

    if (!isNextStepFinal && form.globalStepTitle && fileSelected) {
      form.variantSelections['main'].props.push({
        [form.globalStepTitle]: 'FILE'
      });
    }

    if (!isNextStepFinal && form.globalStepTitle && form.gesvisionValue) {
      form.variantSelections['main'].props.push({
        ['gesvisionValue-' + form.currentIndex]: form.gesvisionValue
      });
    }

    var readingMagnification = form.steps[form.currentIndex].querySelector('input[name="magnification"]:checked');
    if (readingMagnification) {
      var selectedMagnification = readingMagnification.value;
      form.variantSelections['main'].props.push({
        [form.globalStepTitle]: selectedMagnification
      });
    }

    //form.variantSelections = reindexAddOns(form.variantSelections);

    console.log('VARIANTES EN ARRAY', form.variantSelections);

    var nextSteps = form.decisionTree[form.currentIndex + 1];

    if (nextSteps && nextSteps[selectedValue] !== undefined) {  // Verifica el próximo paso basado en la selección
      var nextStep = nextSteps[selectedValue];

      if (nextStep === null) {

        showSubmitButton(form);

      } else if (nextStep !== undefined) {

        if (form.pathTaken.includes(nextStep)) {
          alert(window.language.cicledDetection);
          return;
        }

        form.pathTaken.push(nextStep);
        form.selections[form.currentIndex] = selectedValue;  // Guardar la selección actual (radio o checkbox)

        var currentStepIndex = form.currentIndex; // Guardar el índice del paso actual
        var nextStepIndex = nextStep - 1; // Guardar el índice del siguiente paso

        var currentStepElement = form.steps[currentStepIndex];
        currentStepElement.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
        currentStepElement.style.transform = 'translateX(-100%)';
        currentStepElement.style.opacity = '0';

        //updateFormStep(form, nextStep - 1);
        setTimeout(function () {
          updateFormStep(form, nextStepIndex);
          var nextStepElement = form.steps[form.currentIndex];

          let optionType = nextStepElement.querySelector('[data-option-type]') ? nextStepElement.querySelector('[data-option-type]').getAttribute('data-option-type') : null;
          toggleSummaryAndFooter(optionType);

          nextStepElement.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
          nextStepElement.style.transform = 'translateX(0)';
          nextStepElement.style.opacity = '1';

          if (nextStepElement && nextStepElement.querySelector('[data-option-type="graduation-values"]')) {
            displayGraduationValues(form);
          }

          hideSubmitButton(form);

          var footerElements = document.querySelectorAll('#ce-multi-step .wiz-form__footer');
          var selectedOptions = form.steps[form.currentIndex].querySelectorAll('input[type="checkbox"]:checked');
          if (selectedOptions.length > 0 && form.globalStepControlKey === 'prescription_filters') {
            if (footerElements.length > 0) {
              footerElements.forEach(element => {
                element.style.backgroundColor = 'white';
                element.style.color = 'black';
              });
            }
            Util.removeClass(document.querySelector('.next-button-wrapper'), 'hide');
          } else if (selectedOptions.length > 0 && form.globalStepControlKey === 'accesories') {
            if (footerElements.length > 0) {
              footerElements.forEach(element => {
                element.style.backgroundColor = 'white';
                element.style.color = 'black';
              });
            }
            Util.removeClass(document.querySelector('.next-button-wrapper'), 'hide');
          } else {
            if (footerElements.length > 0) {
              footerElements.forEach(element => {
                element.style.backgroundColor = window.language.footerBackground;
                element.style.color = window.language.footerColor;
              });
            }
            Util.addClass(document.querySelector('.next-button-wrapper'), 'hide');
          }

          form.globalStepControlKey = form.steps[form.currentIndex].getAttribute('data-step-control-key');
          if (form.globalStepControlKey === 'accesories') {
            showSubmitButton(form);
          }

        }, 150);

      } else {
        alert(window.language.noValidOption);
      }
    } else {
      alert(window.language.stepUndefined);
    }

    updateSummary(form);
    resetStepBar(form);
    setBarTotalSteps(form);

  };

  function updateSummary(form) {
    var mainPrice = parseFloat(form.globalPrice) / 100;
    var contactLensesPrice = mainPrice;
    var mainTitle = "";
    var _addonsPrice = 0;
    var addonsTextArray = [];
    var upsellsPrice = 0;
    var upsellsTextArray = [];
    var addonTitle = "";
    var addonPrice = 0;

    // Variables para almacenar el precio de las lentillas (se usará si el producto es de lentillas)
    var leftEyePrice = 0;
    var rightEyePrice = 0;
    var leftEyeQuantity = 0;
    var rightEyeQuantity = 0;
    var lensPrescription = null;

    // Comprobar si estamos manejando lentillas o gafas (verificar si los elementos específicos de lentillas están presentes)
    const isContactLens = document.getElementById('quantity-left') && document.getElementById('quantity-right');
    const leftEyeCheckbox = document.querySelector('.checkbox-control input[name="left-eye-checkbox"]');
    const rightEyeCheckbox = document.querySelector('.checkbox-control input[name="right-eye-checkbox"]');

    if (isContactLens) {
      // Obtener el precio base del producto de lentillas (asumimos que mainPrice es el precio por caja)
      var perBoxPrice = mainPrice;

      // Verificar si el checkbox del ojo izquierdo está marcado, y si es así, calcular el precio
      if (leftEyeCheckbox && leftEyeCheckbox.checked) {
        var quantityLeft = parseInt(document.getElementById('quantity-left').value) || 0;
        leftEyePrice = quantityLeft * perBoxPrice;
      }

      // Verificar si el checkbox del ojo derecho está marcado, y si es así, calcular el precio
      if (rightEyeCheckbox && rightEyeCheckbox.checked) {
        var quantityRight = parseInt(document.getElementById('quantity-right').value) || 0;
        rightEyePrice = quantityRight * perBoxPrice;
      }

      // Calcular el precio total de las lentillas seleccionadas
      contactLensesPrice = leftEyePrice + rightEyePrice;

    }

    // Calcular precios adicionales, upsells, etc.
    Object.keys(form.variantSelections).forEach(key => {
      if (key.startsWith('addon-') && key !== 'addon-0') {
        addonPrice = form.variantSelections[key].price / 100 || 0;
        addonTitle = form.variantSelections[key].title || null;
        _addonsPrice += addonPrice;
        addonsTextArray.push({
          title: addonTitle,
          price: addonPrice.toFixed(2)
        });
      } else if (key.startsWith('upsell-')) {
        var upsellPrice = form.variantSelections[key].price / 100 || 0;
        upsellsPrice += upsellPrice;
        upsellsTextArray.push(form.variantSelections[key].title);
      } else if (key.startsWith('main')) {
        mainTitle = form.variantSelections[key].title;

        // Buscar si `props` tiene `lens_prescription`
        form.variantSelections[key].props.forEach(prop => {
          if (prop.hasOwnProperty('contact_lenses_prescription')) {
            lensPrescription = JSON.parse(prop['contact_lenses_prescription']);
          }
        });

        // Extraer la cantidad de cajas de la prescripción si existe
        if (lensPrescription) {
          if (lensPrescription.leftEye && lensPrescription.leftEye.Quantity) {
            leftEyeQuantity = parseInt(lensPrescription.leftEye.Quantity) || 0;
          }
          if (lensPrescription.rightEye && lensPrescription.rightEye.Quantity) {
            rightEyeQuantity = parseInt(lensPrescription.rightEye.Quantity) || 0;
          }
        }
      }
    });

    // Calcular el precio total incluyendo lentillas (si aplica), addons y upsells
    var totalPrice = contactLensesPrice + _addonsPrice + upsellsPrice;
    var roundedTotalPrice = (totalPrice).toFixed(0);

    // Actualizar todos los elementos de resumen
    var summaryElements = document.querySelectorAll('#ce-multi-step .wiz-form__summary');

    summaryElements.forEach(summary => {
      // Limpiar los elementos addon existentes
      summary.querySelectorAll('.addons-wrapper').forEach(el => el.remove());

      // Crear y agregar elementos addon antes del elemento upsells-wrapper
      var upsellsWrapper = summary.querySelector('.upsells-wrapper');
      var modelPrice = summary.querySelector('.model-wrapper .model-price');

      addonsTextArray.forEach(addon => {
        var addonElement = document.createElement('p');
        addonElement.classList.add('addons-wrapper', 'flex', 'justify-between');
        var addonText = document.createElement('span');
        addonText.classList.add('addons-text', 'padding-right-md');
        addonText.textContent = addon.title;
        var addonPriceSpan = document.createElement('span');
        addonPriceSpan.classList.add('addons-price');
        addonPriceSpan.textContent = `${parseFloat(addon.price).toFixed(0)}${window.language.countryCurrency}`;
        addonElement.appendChild(addonText);
        addonElement.appendChild(addonPriceSpan);
        summary.insertBefore(addonElement, upsellsWrapper);
      });

      // Actualizar el texto de los upsells
      var upsellsText = upsellsTextArray.length > 0 ? `${upsellsTextArray.join(' · ')}` : '';
      summary.querySelector('.upsells-text').textContent = `${upsellsText}`;

      if (form.currentIndex === 0) {
        const modelTextElement = summary.querySelector('.model-text');
        if (form.globalOptionTitle) {
          modelTextElement.textContent = `${mainTitle} · ${form.globalOptionTitle}`;
        } else {
          modelTextElement.textContent = `${mainTitle}`;
        }
        summary.style.borderTop = '1px solid black';
      }

      if (upsellsPrice > 0) {
        Util.removeClass(summary.querySelector('.upsells-wrapper'), 'hide');
      } else {
        Util.addClass(summary.querySelector('.upsells-wrapper'), 'hide');
      }

      // Actualizar los precios en el resumen
      summary.querySelector('.model-price').textContent = `${mainPrice.toFixed(0)}${window.language.countryCurrency}`;
      summary.querySelector('.upsells-price').textContent = upsellsPrice > 0 ? `${upsellsPrice.toFixed(0)}${window.language.countryCurrency}` : '';

      // Mostrar la cantidad de cajas de lentillas si está disponible
      if (lensPrescription || (leftEyeCheckbox && leftEyeCheckbox.checked) || (rightEyeCheckbox && rightEyeCheckbox.checked)) {
        const leftEyeLine = `${window.language.leftEye} - ${leftEyeQuantity} ${window.language.contactLensesQuantity}`;
        const rightEyeLine = `${window.language.rightEye} - ${rightEyeQuantity} ${window.language.contactLensesQuantity}`;
        var leftContactLensesText = summary.querySelector('.left-contact-lenses-wrapper .contact-lenses-text');
        var rightContactLensesText = summary.querySelector('.right-contact-lenses-wrapper .contact-lenses-text');
        var leftContactLensesPrice = summary.querySelector('.left-contact-lenses-wrapper .contact-lenses-price');
        var rightContactLensesPrice = summary.querySelector('.right-contact-lenses-wrapper .contact-lenses-price');

        if (leftEyeCheckbox && leftEyeCheckbox.checked) {
          leftContactLensesText.textContent = leftEyeLine;
          leftContactLensesPrice.textContent = `${leftEyePrice.toFixed(0)}${window.language.countryCurrency}`;
          Util.removeClass(summary.querySelector('.left-contact-lenses-wrapper'), 'hide');
        } else {
          Util.addClass(summary.querySelector('.left-contact-lenses-wrapper'), 'hide');
        }

        if (rightEyeCheckbox && rightEyeCheckbox.checked) {
          rightContactLensesText.textContent = rightEyeLine;
          rightContactLensesPrice.textContent = `${rightEyePrice.toFixed(0)}${window.language.countryCurrency}`;
          Util.removeClass(summary.querySelector('.right-contact-lenses-wrapper'), 'hide');
        } else {
          Util.addClass(summary.querySelector('.right-contact-lenses-wrapper'), 'hide');
        }
        Util.addClass(modelPrice, 'hide');
      } else {
        Util.addClass(summary.querySelector('.left-contact-lenses-wrapper'), 'hide');
        Util.addClass(summary.querySelector('.right-contact-lenses-wrapper'), 'hide');
        Util.removeClass(modelPrice, 'hide');
      }

      var shippingWrapper = summary.querySelector('.shipping-wrapper');
      if (roundedTotalPrice > window.language.freeShippingThreshold) {
        Util.removeClass(shippingWrapper, 'hide');
      } else {
        Util.addClass(shippingWrapper, 'hide');
      }

    });

    // Actualizar el total en el único lugar (footer)
    document.querySelector('#ce-multi-step .wiz-form__footer .total-price').textContent = ` ${roundedTotalPrice}${window.language.countryCurrency}`;

    // Actualizar el botón de agregar al carrito con el precio total
    var submitPriceSpan = document.querySelector('#ce-multi-step .wiz-form__footer .js-wiz-form__submit .submit-price');
    if (submitPriceSpan) {
      submitPriceSpan.textContent = ` ${roundedTotalPrice}${window.language.countryCurrency}`;
    }
  }

  function toggleSummaryAndFooter(optionType) {
    const summaryElements = document.querySelectorAll('#ce-multi-step .wiz-form__summary');
    const footerElement = document.querySelector('#ce-multi-step .wiz-form__footer');

    if (optionType === 'graduation-values' || optionType === 'graduation-selectors' || optionType === 'file' || optionType === 'reading-values' || optionType === 'contactlenses_graduation') {
      summaryElements.forEach(summary => {
        summary.classList.add('not-show');
      });
      footerElement.classList.add('not-show');
    } else {
      summaryElements.forEach(summary => {
        summary.classList.remove('not-show');
      });
      footerElement.classList.remove('not-show');
    }
  };

  function displayGraduationValues(form) {
    var reversedProps = [...form.variantSelections['main'].props].reverse();
    var graduationValues = reversedProps.find(function (prop) {
      return prop.hasOwnProperty(form.gesvisionValue);
    });
    if (graduationValues) {
      var graduation = JSON.parse(graduationValues[form.gesvisionValue]);
      document.getElementById('confirmation-right-eye-sph').textContent = graduation.rightEye.SPH;
      document.getElementById('confirmation-right-eye-cyl').textContent = graduation.rightEye.CYL;
      document.getElementById('confirmation-right-eye-axis').textContent = graduation.rightEye.Axis;
      document.getElementById('confirmation-right-eye-add').textContent = graduation.rightEye.Add;
      document.getElementById('confirmation-right-eye-pd').textContent = graduation.rightEye.PD;
      document.getElementById('confirmation-left-eye-sph').textContent = graduation.leftEye.SPH;
      document.getElementById('confirmation-left-eye-cyl').textContent = graduation.leftEye.CYL;
      document.getElementById('confirmation-left-eye-axis').textContent = graduation.leftEye.Axis;
      document.getElementById('confirmation-left-eye-add').textContent = graduation.leftEye.Add;
      document.getElementById('confirmation-left-eye-pd').textContent = graduation.leftEye.PD;
    }
  };

  function handlePrevStep(form) {
    form.pathTaken.pop();

    //var previousStep = form.pathTaken.length > 0 ? form.pathTaken[form.pathTaken.length - 1] : 0;
    var previousStepIndex = form.pathTaken.length > 0 ? form.pathTaken[form.pathTaken.length - 1] - 1 : 0;
    var currentStepIndex = form.currentIndex;

    // Establece la transición para el paso actual (saliente)
    var currentStepElement = form.steps[currentStepIndex];
    currentStepElement.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
    currentStepElement.style.transform = 'translateX(100%)';
    currentStepElement.style.opacity = '0';

    setTimeout(function () {
      updateFormStep(form, previousStepIndex);

      var previousStepElement = form.steps[form.currentIndex];
      previousStepElement.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
      previousStepElement.style.transform = 'translateX(0)';
      previousStepElement.style.opacity = '1';

      let optionType = previousStepElement.querySelector('[data-option-type]') ? previousStepElement.querySelector('[data-option-type]').getAttribute('data-option-type') : null;
      toggleSummaryAndFooter(optionType);

      form.globalStepControlKey = form.steps[form.currentIndex].getAttribute('data-step-control-key');
      var footerElements = document.querySelectorAll('#ce-multi-step .wiz-form__footer');
      var selectedOptions = form.steps[form.currentIndex].querySelectorAll('input[type="checkbox"]:checked');
      if (selectedOptions.length > 0 && form.globalStepControlKey === 'prescription_filters') {
        if (footerElements.length > 0) {
          footerElements.forEach(element => {
            element.style.backgroundColor = 'white';
            element.style.color = 'black';
          });
        }
        Util.removeClass(document.querySelector('.next-button-wrapper'), 'hide');
      } else {
        if (footerElements.length > 0) {
          footerElements.forEach(element => {
            element.style.backgroundColor = window.language.footerBackground;
            element.style.color = window.language.footerColor;
          });
        }
        Util.addClass(document.querySelector('.next-button-wrapper'), 'hide');
      }

    }, 150);

    restoreSelection(form, previousStepIndex);
    hideSubmitButton(form);
    resetAddOnsAndUpsellsFromStep(form, previousStepIndex);

    console.log('VARIANT SELECTIONS ARRAY', form.variantSelections);
  };

  function resetAddOnsAndUpsellsFromStep(form, stepIndex) {
    Object.keys(form.variantSelections).forEach(key => {
      if (key.startsWith('addon-') && parseInt(key.split('-')[1]) >= stepIndex) {
        delete form.variantSelections[key];
      }
      if (key.startsWith('upsell-')) {
        delete form.variantSelections[key];
      }
    });

    if (!form.isGoingForward && form.variantSelections['main'] && form.variantSelections['main'].props) {
      var graduationIndex = form.variantSelections['main'].props.findIndex(prop => prop.graduation);
      if (graduationIndex !== -1) {
        form.variantSelections['main'].props.splice(graduationIndex, 1);
      }
    }

    const fileInput = form.element.querySelector('input[type="file"]');
    const fileButton = form.element.querySelector('.ce-button-file');
    if (fileInput && !form.isGoingForward) {
      fileInput.value = '';
      const label = fileInput.closest('.file-upload').querySelector('.file-upload__label');
      const textElement = label.querySelector('.file-upload__text');
      textElement.textContent = label.getAttribute('data-option-title');
      fileButton.disabled = true;
    }

    //form.variantSelections = reindexAddOns(form.variantSelections);
  }

  function reindexAddOns(variantSelections) {
    const newVariantSelections = {};
    let addonIndex = 1;
    let upsellIndex = 1;

    if (variantSelections.main) {
      newVariantSelections.main = variantSelections.main;
    }

    Object.keys(variantSelections).forEach(key => {
      if (key.startsWith('addon-')) {
        newVariantSelections['addon-' + addonIndex] = variantSelections[key];
        addonIndex++;
      } else if (key.startsWith('upsell-')) {
        newVariantSelections['upsell-' + upsellIndex] = variantSelections[key];
        upsellIndex++;
      }
    });

    return newVariantSelections;
  }

  function showSubmitButton(form) {
    var submitButton = form.formSubmit[0];
    var nextButton = form.navNext[0];
    if (submitButton && nextButton) {
      submitButton.classList.remove('hide');
      nextButton.classList.add('hide');
      Util.addClass(document.querySelector('#ce-multi-step .wiz-form__footer .total-wrapper'), 'hide');
      document.querySelector('#ce-multi-step .wiz-form__footer').style.backgroundColor = 'white';
      document.querySelector('#ce-multi-step .wiz-form__footer').style.paddingTop = '4px';
      document.querySelector('#ce-multi-step .wiz-form__footer').style.paddingBottom = '8px';
    }
  };

  function hideSubmitButton(form) {
    var submitButton = form.formSubmit[0];
    var nextButton = form.navNext[0];
    if (submitButton && nextButton) {
      submitButton.classList.add('hide');
      nextButton.classList.remove('hide');
      Util.removeClass(document.querySelector('#ce-multi-step .wiz-form__footer .total-wrapper'), 'hide');
      const footerBgColor = document.querySelector('#ce-multi-step .wiz-form__footer').getAttribute('data-bg-color');
      document.querySelector('#ce-multi-step .wiz-form__footer').style.backgroundColor = footerBgColor;
      document.querySelector('#ce-multi-step .wiz-form__footer').style.removeProperty('padding-top');
      document.querySelector('#ce-multi-step .wiz-form__footer').style.removeProperty('padding-bottom');
    }
  };

  function getSelectedStep(form) {
    var selectedStep = form.element.getElementsByClassName(form.currentClass);
    form.currentIndex = (selectedStep.length > 0) ? Util.getIndexInArray(form.steps, selectedStep[0]) : 0;
    setStepsClass(form);
  };

  function setStepsClass(form) {
    for (var i = 0; i < form.steps.length; i++) {
      if (i < form.currentIndex) {
        Util.addClass(form.steps[i], form.stepPrevClass);
        Util.removeClass(form.steps[i], form.stepNextClass + ' ' + form.currentClass);
      } else if (i > form.currentIndex) {
        Util.addClass(form.steps[i], form.stepNextClass);
        Util.removeClass(form.steps[i], form.stepPrevClass + ' ' + form.currentClass);
      } else {
        Util.addClass(form.steps[i], form.currentClass);
        Util.removeClass(form.steps[i], form.stepNextClass + ' ' + form.stepPrevClass);
      }
    }
  };

  function resetNav(form) {
    if (form.navPrev.length > 0) {
      form.currentIndex > 0 ? Util.removeClass(form.navPrev[0], 'hide') : Util.addClass(form.navPrev[0], 'hide');
    }
    if (form.navNext.length > 0 && form.formSubmit.length > 0) {
      if (form.currentIndex == (form.steps.length - 1)) {
        Util.addClass(form.navNext[0], 'hide');
        Util.removeClass(form.formSubmit[0], 'hide');
      } else {
        Util.removeClass(form.navNext[0], 'hide');
        Util.addClass(form.formSubmit[0], 'hide');
      }
    }
  };

  function setBarTotalSteps(form) {
    if (form.stepsBarTot && form.stepsBarTot.length > 0) {
      var totalSteps = calculateTotalSteps(form);
      form.stepsBarTot[0].textContent = " " + totalSteps;
      form.stepsBar[0].style.setProperty('--steps-v2-steps-nr', totalSteps);
      updateProgressBar(form);
    }
  };

  function resetStepBar(form) {
    if (form.stepsBarCurrent && form.stepsBarCurrent.length > 0) {
      var currentStepIndex = form.pathTaken.length + 1;
      form.stepsBar[0].style.setProperty('--step-v2-current-step', currentStepIndex);
      form.stepsBarCurrent[0].textContent = " " + currentStepIndex;
      updateProgressBar(form);
    }
  };

  function calculateTotalSteps(form) {
    var currentStep = form.currentIndex + 1;
    var totalSteps = form.pathTaken.length + 1;

    var path = form.decisionTree[currentStep];

    while (path && Object.values(path).some(step => step !== null)) {
      var nextStep = path[Object.keys(path)[0]]; // Tomar el primer paso del camino
      if (nextStep !== null) {
        totalSteps++;
        path = form.decisionTree[nextStep];
      } else {
        break;
      }
    }

    return totalSteps;
  };

  function updateProgressBar(form) {
    var currentStepIndex = form.pathTaken.length + 1;
    var totalSteps = calculateTotalSteps(form);
    var progressPercentage = (currentStepIndex / totalSteps) * 100;

    var progressBarFill = form.element.querySelector('.progress-bar__fill');
    var progressBarAriaValue = form.element.querySelector('.js-progress-bar__aria-value');

    if (progressBarFill) {
      progressBarFill.style.width = `${progressPercentage}%`;
    }

    if (progressBarAriaValue) {
      progressBarAriaValue.textContent = `${progressPercentage.toFixed(0)}%`;
    }
  };

  function restoreSelection(form, currentIndex) {
    if (currentIndex >= 0 && currentIndex < form.steps.length) {
      let currentStep = form.steps[currentIndex];
      let savedOptionValue = form.selections[currentIndex];
      if (savedOptionValue) {
        let optionToSelect = currentStep.querySelector(`input[type="radio"][value="${savedOptionValue}"]`);
        if (optionToSelect) {
          optionToSelect.checked = true;
        }
      }
    }
  }

  function updateFormStep(form, step) {
    form.currentIndex = step;
    updateForm(form);
    resetStepBar(form);
    setBarTotalSteps(form);
    updateProgressBar(form);
  }

  function updateForm(form) {
    if (form.currentIndex < 0) form.currentIndex = 0;
    if (form.currentIndex > form.steps.length) form.currentIndex = form.steps.length;
    setStepsClass(form);
    resetNav(form);
  };

  window.WizardForm = WizardForm;

}());
